// rootReducer.js
import { combineReducers } from "redux";
import radioButtonReducer from "./radioButtonSlice";

const rootReducer = combineReducers({
  radioButton: radioButtonReducer,
  // other slices can be added here
});

export default rootReducer;
